import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private loadedScripts: { [key: string]: boolean } = {};

  constructor() {}

  loadScripts(scriptUrls: string[]): void {
    scriptUrls.forEach((url) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => {
          this.loadedScripts[url] = true;
          console.log(`Script loaded: ${url}`);
        };
        document.body.appendChild(script);

    });
  }
}
